<i18n lang='yml' src='../i18n/BookingForm.yml'></i18n>
<template>
  <div>
    <div class="heading-block mb-0 d-flex">
      <h4 v-if="activeStep =='training-program'">
        {{$t('training_program', { type: booking.user_name} )}}
      </h4>
      <h4 v-else-if="activeStep =='user-search'">
        {{$t('user_search')}}
      </h4>
      <h4 v-else>
        {{$t('book_exam')}}
      </h4>
      <button v-if="activeStep != 'user-search' && activeStep != 'training-program'" class="btn btn-light ml-auto" @click="cancelBooking">
        <font-awesome-icon :icon="['fa', 'times']"/>
        {{ $t('cancel') }}
      </button>
    </div>
    <Stepper :admin="admin" :activeStep="activeStep" @stepClicked="setActive" :includeAccommodation="booking.accommodation == 'true'" :type="type"/>
    <booking-user-search 
      :locale="locale" 
      :amanda_integration="amanda_integration" 
      :base_path="base_path" id="user-search" 
      :pagination_limit="pagination_limit"
      :active="activeStep=='user-search'"
      @nextStep="nextStep" 
      @userChange="setField"
      @userEligibility="setUserEligibility"
    />
    <booking-training-programs :locale="locale"
      :base_path="base_path"
      :active="activeStep=='training-program'"
      id="training-program"
      :details="booking"
      :english_resources_link="english_resources_link"
      :french_resources_link="french_resources_link"
      @nextStep="nextStep"
      @trainingProgramChange="setField"
      @userEligibility="setUserEligibility"
      :admin="admin"
      :time_format_en="time_format_en" :time_format_fr="time_format_fr"
    />
    <booking-exam-type 
      :locale="locale" :details="booking" 
      :training_program_name="booking.training_program_name" 
      :training_program_id="booking.training_program_id"
      :base_path="base_path" 
      :english_exam_prep_link="english_exam_prep_link"
      :french_exam_prep_link="french_exam_prep_link"
      :active="activeStep=='exam-type'"
      :admin="admin"
      @nextStep="nextStep" 
      @languageChange="setField" 
      @examTypeChange="setField" 
      @accommodationChange="setField"/>
    <booking-accommodation 
      :locale="locale"
      :active="activeStep=='accommodation'"
      :base_path="base_path"
      :admin="admin"
      :details="booking"
      @nextStep="nextStep"
      @accommodationChange="setField"
      :english_scheduling_link="english_scheduling_link"
      :french_scheduling_link="french_scheduling_link"
    />
    <booking-sitting :active="activeStep=='sitting'" 
      @nextStep="nextStep" 
      @sittingChange="setField" 
      :userEligibility="userEligibility"
      :base_path="base_path" 
      :sub_locations_path="sub_locations_path" 
      :details="booking" :locale="locale" 
      :sub_locations="sub_locations" 
      :booking_holds_path="booking_holds_path"
      :admin="admin"
      :type="type"
      :time_format_en="time_format_en" :time_format_fr="time_format_fr"
    />
    <booking-review
      @nextStep="nextStep"
      :active="activeStep=='review'" 
      :locale="locale" 
      :details="booking"
      :base_path="base_path"
      :time_format_en="time_format_en" :time_format_fr="time_format_fr"
    />
    <!-- <booking-payment 
      @nextStep="nextStep" 
      :active="activeStep=='payment'" 
      :locale="locale" 
      :details="booking" 
      :admin="admin"
      :base_path="base_path"
      :paymentPageUrl="payment_page_url"
      :paymentPageTransactionKey="payment_page_transaction_key"
      :paymentPageLogin="payment_page_login"
      :time_format_en="time_format_en" :time_format_fr="time_format_fr"
      :availableCredit="amanda_integration == 'false' || availableCredit()"
    /> -->
  </div>
</template>
<script>
import BookingAccommodationVue from './BookingAccommodation.vue'
import BookingExamTypeVue from './BookingExamType.vue'
import BookingPaymentVue from './BookingPayment.vue'
import BookingSittingVue from './BookingSitting.vue'
import BookingTrainingProgramsVue from './BookingTrainingPrograms.vue'
import BookingUserSearchVue from './BookingUserSearch.vue'
import BookingReviewVue from './BookingReview.vue'
import Stepper from './Stepper.vue'
import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';

export default {
  props: ['locale', 'base_path', 'payment_page_url', 'payment_page_login', 'payment_page_transaction_key', 'amanda_integration',
   'admin', 'sub_locations_path', 'sub_locations', 'pagination_limit', 'current_user_identity', 'booking_holds_path', 'type', 'booking_data',
   'english_exam_prep_link', 'french_exam_prep_link', 'english_resources_link', 'french_resources_link', 'time_format_en', 'time_format_fr',
   'english_scheduling_link', 'french_scheduling_link'
  ],
  components: {
    'booking-user-search': BookingUserSearchVue,
    'booking-accommodation': BookingAccommodationVue,
    'booking-exam-type': BookingExamTypeVue,
    'booking-payment': BookingPaymentVue,
    'booking-sitting': BookingSittingVue,
    'booking-training-programs': BookingTrainingProgramsVue,
    'booking-review': BookingReviewVue,
    Stepper
  },
  data() {
    return {
      activeStep: 'user-search',
      booking: {},
      userEligibility: null,
      steps: 3, step: undefined
    }
  },
  mounted() {
    if(this.admin == 'false') {
      try {
        let userIdentity = JSON.parse(this.current_user_identity)
        this.setField({
          user_name: userIdentity.full_name,
          sto_id: userIdentity.external_identifiers ? userIdentity.external_identifiers.sto_id : '',
          user_identity_id: userIdentity.id
        })
      }
      catch {
        console.log("Error loading user")
      }
      this.activeStep = 'training-program'
    }
    if(this.admin == 'true' && this.type == 'edit') {
      try {
        this.booking = JSON.parse(this.booking_data);
        this.activeStep = 'sitting';
      }
      catch {
        console.log("Error loading booking")
      }
    }
    this.scrollIntoView()
  },
  methods: {
    cancelBooking() {
      if(confirm(this.$t('cancel_confirmation'))) {
        window.location.replace(this.base_path)
      }
    },
    setField(field_name) {
      for (const [key, value] of Object.entries(field_name)) {
        if (key == 'accommodation' && value == 'false') {
          if (this.booking.accommodations) {
            this.booking.accommodations.accommodation_types = []
            this.booking.accommodations.additional_information = ''
            this.booking.accommodations.reason = ''
          }
          
        }
        this.booking[key] = value
      };  
    },
    setUserEligibility(details) {
      this.userEligibility = details
    },
    availableCredit() {
      if(!this.userEligibility) {
        return false
      }

      let trade = this.userEligibility.find((trade) => {return trade.id == this.booking.training_program_id})
      return trade ? trade.eligibility.credit_available : false
    },
    setActive(item) {
      this.activeStep = item
 
    },
    scrollIntoView: function() {
      const element = document.getElementsByClassName("heading-block")[0];
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },

    confirmBooking() {
      this.type == 'edit' ? sendAjaxRequest('PUT', `${this.base_path}/${this.booking.id}`, 'json', {booking: this.booking}, this.ajaxSuccess, this.ajaxError) : sendAjaxRequest('POST', this.base_path, 'json', {booking: this.booking}, this.ajaxSuccess, this.ajaxError)
    },

    ajaxSuccess(data) {
      this.loading = false;
      this.subLocations = data
      if(data.path) {
        window.location.replace(data.path)
      }
    },


    ajaxError() {
      this.loading = false;
      alert(this.$t('error_loading'));
    },

    nextStep() {
      switch(this.activeStep) {
        case 'user-search':
          this.activeStep = 'training-program'
          break;
        case 'training-program':
          this.type == 'edit' ?  this.activeStep = 'sitting' : this.activeStep = 'exam-type'
          break;
        case 'exam-type':
          this.activeStep = (this.booking.accommodation == 'true' && this.admin ? 'accommodation' : 'sitting')
          break;
        case 'accommodation':
          this.activeStep = 'sitting'
          break;
        case 'sitting':
          this.activeStep = 'review'
          break;
          // if(this.amanda_integration && this.type != 'edit') {
            
          //   this.activeStep = 'payment'
          // }
          // else {
          //   this.confirmBooking()
          // }
        // case 'payment':
        case 'review':
          this.confirmBooking()
          break;

      }   
      this.scrollIntoView()
    },
  }
}
</script>
